import type { SupabaseClientOptions } from '@supabase/supabase-js';

export const browserAuthOptions = {
  autoRefreshToken: true,
  detectSessionInUrl: true,
  persistSession: true,
} satisfies NonNullable<SupabaseClientOptions<'public'>['auth']>;
